
<form [formGroup]="addUserForm" (ngSubmit) = "onSubmit()">
  <p-dialog  [(visible)]="displayDialog" 
      [modal]="true" 
      [positionTop]="50" 
      [maximizable]="true"
      [contentStyle]="{'min-width':'1000px'}"
      (onHide)="dialogClose()"
      >
      <p-header>
        <b>Add User</b> {{ (email.valid && activeIndex !=0) ?  email.value : ''}}
      </p-header>

    <eq-wizard [(activeIndex)]="activeIndex" [readonly]="readonly">
      <eq-wizard-step label="Partner Email">
        <div class="ui-grid ui-grid-responsive ui-fluid formcontainer"> 
          <div formGroupName="PersonDetail">
            <div class="formgroup">
              <div class="ui-grid-row">
                  <div class="ui-grid-col-12">
                      <input id="email" name="email" placeholder="Email Address" type="text" formControlName="Email" pInputText />
                      <div *ngIf="email.invalid && (email.dirty || email.touched) && (email.errors.required || email.errors.email || email.errors.invalidEmail)" class="custom-required">
                          Please enter a valid Email
                      </div>
                      <div *ngIf="email.pending">Email Verification in progress...</div>
                      <div class="custom-required" *ngIf="email.invalid && (email.dirty || email.touched) && email.errors.emailExists">
                          This user already exists
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>        
        <button pButton label="Next" (click)="next()" icon="pi pi-angle-right" [disabled]="processing || email.invalid || email.pending"></button>
      </eq-wizard-step>

      <eq-wizard-step label="Partner Details">
        <div formGroupName="Relationship">
          <div class="ui-grid ui-grid-responsive ui-fluid formcontainer">               
              <div class="formgroup">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-12">                 
                  </div>
                </div>
                <div class="ui-grid-row">
                  <div class="ui-grid-col-1">                 
                      <label for="AddPartnership" class="bold-label">Access</label> 
                  </div>
                  <div class="ui-grid-col-3">
                    <button pButton label="Add Partnership" 
                      (click)="addPartnership()"
                      type="button" 
                      [disabled]="processing || relationGroup.invalid"
                      *ngIf="partnershipCount > 1"></button>
                  </div>
                  <div class="ui-grid-col-8"> 
                  </div>
                </div>
              </div>
              <!-- Privileges  Grid Start -->
              <div class="formgroup">              
                <div class="ui-grid-row">
                  <div class="ui-grid-col-12">
                    <p-table [value]="userPartnerRelationship" autoLayout=true [paginator]="userPartnerRelationship.length > 10" [loading]="loading" [rows]="10"
                      [rowsPerPageOptions]="[10,25,50,100]" >                      
                      <ng-template pTemplate="header">
                          <tr>
                            <th>Partnership</th>
                            <th colspan="2">Asset Groups</th>
                            <th colspan="4">Privileges</th>
                            <th >Remove</th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-userPartnerRelationship let-expanded="expanded" let-rowIndex="rowIndex">
                          <tr>
                              <td>{{userPartnerRelationship.Relationship[0].RelationshipName}}</td>
                              <td colspan="2">
                                <span *ngIf="userPartnerRelationship.Relationship[0].RelationshipDataGroup.length < 2">
                                  {{userRelationshipSvc.assetGroupList(userPartnerRelationship.Relationship[0].RelationshipDataGroup)}}
                                </span>
                                <span *ngIf="userPartnerRelationship.Relationship[0].RelationshipDataGroup.length >= 2"
                                  >{{userRelationshipSvc.assetGroupList(userPartnerRelationship.Relationship[0].RelationshipDataGroup.slice(0,1))}}
                                    <i class="hoverLink" (mouseover)="displayMoreDialog(moreDialog, $event, userPartnerRelationship.Relationship[0].RelationshipDataGroup,'ASSETGROUP')"
                                    (mouseout)="moreDialog.hide($event)">+More</i>
                                </span>
                              </td>
                              <td colspan="4">
                                <span>
                                  {{userRelationshipSvc.privilegeList(userPartnerRelationship.Relationship[0].Privileges,userPartnerRelationship.Relationship[0].PrivilegeGroups).substr(0,75)}}
                                  <i class="hoverLink" 
                                    (mouseover)="displayMoreDialog(privilegMoreDialog, $event,userPartnerRelationship.Relationship[0],'PRIVILEGES')" 
                                    (mouseout)="privilegMoreDialog.hide($event)">+More</i>
                                </span>  
                              </td>
                               <td>
                                  <i class="pi pi-fw pi-trash action" (click)="removeUserRelationshipConfirm(rowIndex)"></i>                
                              </td> 
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="footer">
                        <tr>
                          <td>
                            <app-partnership-dropdown 
                              [relationship]="relationship"
                              [maxSelectedLabels]="1"
                              defaultLabel="Select Partnership" 
                              filterPlaceHolder=""
                              formControlName="Relationship"
                              (onPartnershipCount)="onPartnershipCount($event)"
                              (onChange)="partnershipChange($event)"
                              [relationshipExclude]="relationshipExclude"
                              [relationshipInclude]="relationshipInclude"
                              >
                            </app-partnership-dropdown>
                            <div *ngIf="relationshipControl.invalid && relationshipControl.touched 
                                  && relationshipControl.errors.required 
                                  && !userPartnerRelationship.length" 
                                class="custom-required">
                              Please select a Partnership.
                            </div>
                          </td>
                          <td>
                             <app-asset-group-dropdown
                              [relationshipDataGroupSelected]="relationshipDataGroup" 
                              [relationship]="relationship"
                              [maxSelectedLabels]="1"
                              [group]=true
                              defaultLabel="Select Asset Group" 
                              filterPlaceHolder=""
                              formControlName="RelationshipDataGroup"
                              (onChange)="assetGroupChange($event)">
                            </app-asset-group-dropdown>                            
                            <div *ngIf="relationshipDataGroupControl.invalid 
                              && relationshipDataGroupControl.touched
                              && relationshipDataGroupControl.errors.required
                              && !userPartnerRelationship.length" class="custom-required">
                              Please select an Asset Group.
                            </div>
                          </td>
                            <td> 
                                <i (mouseover)="displaySelectedItems(op2, $event, 'RelationshipDataGroup',relationshipDataGroup)" 
                                  (mouseout)="op2.hide($event)">
                                  <span [ngClass]="{'check-circle-gray': relationshipDataGroupControl.invalid,
                                                    'check-circle-green': !relationshipDataGroupControl.invalid}">
                                    <i class="pi pi-check-circle"></i>
                                  </span>
                                </i>
                            </td>
                            <td>
                              <app-privilege-group-dropdown
                                [privilegeGroup]="privilegeGroup"
                                [privilegeGroupSelected] ="userPrivilegeGroupSelected"
                                [maxSelectedLabels]="1"
                                defaultLabel="Select Privilege Group" 
                                filterPlaceHolder=""
                                formControlName = "PrivilegeGroup"
                                (onChange) = "onPrivilegeGroupChange($event)"> 
                              </app-privilege-group-dropdown>
                              <div *ngIf="privilegeGroupControl.invalid 
                                && privilegeGroupControl.touched
                                && privilegeGroupControl.errors.required
                                && !userPartnerRelationship.length" class="custom-required">
                                Please select a Privilege Group.
                              </div>
                            </td>
                            <td>
                              <i (mouseover)="displaySelectedItems(op4, $event, 'PrivilegeGroup')" 
                                (mouseout)="op4.hide($event)">
                                <span [ngClass]="{'check-circle-gray': (privilegeGroupControl.invalid || privilegeGroupSelected.length === undefined
                                                                        || privilegeGroupSelected.length <= 0),
                                                  'check-circle-green': (!privilegeGroupControl.invalid && privilegeGroupSelected.length !== undefined
                                                  							&& privilegeGroupSelected.length)}"> 
                                  <i class="pi pi-check-circle"></i>
                                </span>
                              </i>
                            </td>
                            <td>  
                              <app-privilege-dropdown 
                                [privilegeGroup] = "relationshipPrivilege"
                                formControlName="Privilege"                               
                                (onChange) = "privilegeChange($event)"
                                [maxSelectedLabels]="1"
                                [group]=true
                                defaultLabel="Select Privilege" 
                                filterPlaceHolder="">
                              </app-privilege-dropdown>
                              <div *ngIf="privilegeDataControl.invalid 
                                && privilegeDataControl.touched
                                && privilegeDataControl.errors.required
                                && !userPartnerRelationship.length" class="custom-required">
                                Please select a Privilege.
                              </div>
                            </td>
                            <td>
                              <i (mouseover)="displaySelectedItems(op1, $event, 'Privileges',privilegesSelectedToolTip)" 
                                (mouseout)="op1.hide($event)">
                                <span [ngClass]="{'check-circle-gray': (privilegeDataControl.invalid  || privilegesSelected.length === undefined 
                                                                          || privilegesSelected.length <= 0 ),
                                                  'check-circle-green': (!privilegeDataControl.invalid && privilegesSelected.length !== undefined 
                                                                          && privilegesSelected.length)}">
                                  <i class="pi pi-check-circle"></i>
                                </span>
                              </i>
                            </td>
                        </tr>
                    </ng-template>
                  </p-table>
                  </div>
                </div>
              </div>
              <!-- Privileges Grid End -->
          </div>
        </div>
        <div class="ui-grid ui-grid-responsive formcontainer"> 
          <div class="formgroup">
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <button pButton label="Back" (click)="back()" icon="pi pi-angle-left" class="ui-button-secondary"></button>
                &nbsp;
                <button pButton label="Continue" (click)="next()" icon="pi pi-angle-right" 
                    [disabled]="processing || ((relationship.length > 0 || userPartnerRelationship.length <= 0) &&  relationGroup.invalid)"></button>
              </div>
            </div>
          </div>
        </div>
        
      </eq-wizard-step>

      <eq-wizard-step label="Confirm">
          <div class="ui-grid ui-grid-responsive ui-fluid formcontainer"> 
              <div class="formgroup">
                  <div class="ui-grid-row">
                      <div class="ui-grid-col-12">
                          <label>Email Address</label>
                      </div>
                  </div>
                  <div class="ui-grid-row">
                      <div class="ui-grid-col-12">
                          {{email.value}}
                      </div>
                  </div>
              </div>
              <div class="formgroup">
                  <div class="ui-grid-row">
                      <div class="ui-grid-col-12">
                          <label>Access</label>
                      </div>
                  </div>
                  <div class="ui-grid-row">
                      <div class="ui-grid-col-12">
                        <p-table [value]="userPartnerRelationship" autoLayout=true [paginator]="userPartnerRelationship.length > 10" [loading]="loading" [rows]="10"
                         [rowsPerPageOptions]="[10,25,50,100]" >
                      
                          <ng-template pTemplate="header">
                              <tr>
                                <th>Partnership</th>
                                <th>Asset Groups</th>
                                <th>Privileges</th>
                              </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-userPartnerRelationship let-expanded="expanded" let-rowIndex="rowIndex">
                              <tr>
                                  <td>{{userPartnerRelationship.Relationship[0].RelationshipName}}</td>
                                  <td>
                                    <span *ngIf="userPartnerRelationship.Relationship[0].RelationshipDataGroup.length < 2">
                                      {{userRelationshipSvc.assetGroupList(userPartnerRelationship.Relationship[0].RelationshipDataGroup)}}
                                    </span>
                                    <span *ngIf="userPartnerRelationship.Relationship[0].RelationshipDataGroup.length >= 2"
                                      >{{userRelationshipSvc.assetGroupList(userPartnerRelationship.Relationship[0].RelationshipDataGroup.slice(0,1))}}
                                        <i class="hoverLink" (mouseover)="displayMoreDialog(moreDialog, $event, userPartnerRelationship.Relationship[0].RelationshipDataGroup,'ASSETGROUP')"
                                        (mouseout)="moreDialog.hide($event)">+More</i>
                                    </span>
                                  </td>
                                  <td>
                                    <span>
                                        {{userRelationshipSvc.privilegeList(userPartnerRelationship.Relationship[0].Privileges, userPartnerRelationship.Relationship[0].PrivilegeGroups).substr(0,15)}}
                                        <i class="hoverLink" 
                                          (mouseover)="displayMoreDialog(privilegMoreDialog, $event,userPartnerRelationship.Relationship[0],'PRIVILEGES')" 
                                          (mouseout)="privilegMoreDialog.hide($event)">+More</i>
                                    </span>
                                  </td>
                              </tr>
                          </ng-template>     
                        </p-table>
                      </div>
                  </div>
              </div>               
            </div>
            <button pButton label="Back" (click)="back()" icon="pi pi-angle-left" class="ui-button-secondary"></button>
      </eq-wizard-step>      
    </eq-wizard>
    
    <p-footer *ngIf="activeIndex === 2">
        <button pButton label="Cancel" class="ui-button-secondary" (click)="cancel()"></button>
        <button pButton label="{{processing ? 'Processing' : 'Create User'}}" type="submit" [disabled]="processing"></button>
    </p-footer>
  </p-dialog>
  </form>
  <p-overlayPanel #moreDialog [dismissable]="true" class="no-flicker">
      {{moreDialogData}}
  </p-overlayPanel>
  <p-overlayPanel #op1 [dismissable]="true" class="no-flicker">
    <div *ngFor="let group of displayItems">
      <ul>
        <li>
          <b>{{group.Key}}</b>
          <ul>
            <li *ngFor="let privilege of group.Privilege">{{privilege.PrivilegeName}}</li>
          </ul>
        </li>
      </ul>
    </div> 
  </p-overlayPanel>
  <p-overlayPanel #op2 [dismissable]="true" class="no-flicker">
    <div>                
      <ul>
        <li *ngFor="let rel of displayItems">{{rel.RelationshipGroupName}}</li>
      </ul>        
    </div>
  </p-overlayPanel>
  <p-confirmDialog [header]="confirmHeader" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <p-overlayPanel #op4 [dismissable]="true" class="no-flicker">
    <div *ngFor="let group of displayItems">
      <ul>
        <li>
          <b>{{group.GroupName}}</b>
          <ul>
            <li *ngFor="let privilege of group.Privileges">{{privilege.PrivilegeName}}</li>
          </ul>
        </li>
      </ul>
    </div>
  </p-overlayPanel>
  <p-overlayPanel #privilegMoreDialog [dismissable]="true" class="no-flicker">
      <div *ngFor="let group of privilegeGroupMoreData">
          <ul>
              <li>
              <b>{{group.GroupName}}</b>
              <ul>
                  <li *ngFor="let privilege of group.Privileges">{{privilege.PrivilegeName}}</li>
              </ul>
              </li>
          </ul>
      </div>     
      <div *ngFor="let privilege of privilegeMoreData">
          <ul>
              <li>
              {{privilege.PrivilegeName}}
              </li>
          </ul>
      </div>      
  </p-overlayPanel>